import React, { useEffect } from 'react';
import './style.css';
import './bootstrap.min.css';

function Aboutus() {
    
    useEffect(() => {
        // பக்கத்தின் தலைப்பு மற்றும் மெட்டா விவரங்கள்
        document.title = "About Us | Unicell Technologies Limited";
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute('content', "Learn more about Unicell Technologies. With over 40 years of excellence in paper manufacture, recycling, and renewable energy.");
        }

        // Owl Carousel செட்டிங்ஸ் (jQuery இருந்தால் மட்டும் இயங்கும்)
        if (window.$ && window.$(".vendor-carousel").length > 0) {
            window.$(".vendor-carousel").owlCarousel({
                loop: true,
                margin: 45,
                dots: false,
                loop: true,
                autoplay: true,
                smartSpeed: 1000,
                responsive: {
                    0: { items: 2 },
                    576: { items: 4 },
                    768: { items: 6 },
                    992: { items: 8 }
                }
            });
        }
    }, []);

    return (
        <>
            {/* About Section */}

         <div className="container-fluid bg-primary py-5 bg-header">
            <div className="row py-5">
                <div className="col-12 pt-lg-5 mt-lg-5 text-center">
                    <h1 className="display-4 text-white animated zoomIn">About Us</h1>
                    <a href="" className="h5 text-white">Home</a>
                    <i className="far fa-circle text-white px-2"></i>
                    <a href="" className="h5 text-white">About</a>
                </div>
            </div>
        </div>
            <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container py-5">
                    <div className="row g-5">
                        <div className="col-lg-7">
                            <div className="section-title position-relative pb-3 mb-5">
                                <h5 className="fw-bold text-primary text-uppercase">About Us</h5>
                                <h1 className="mb-0">The best solutions with over 40 years of experience</h1>
                            </div>
                            <p className="mb-4">
                                The Unicell team has operated diversified businesses, with a core competency in paper manufacture in which they have been involved for over 5 decades. 
                                We have built Greenfield paper mill operations in South Africa, Zambia, U.A.E, USA, and more.
                            </p>
                            <div className="row g-2 mb-4">
                                <div className="col-sm-6"><i className="fa fa-check text-primary me-2"></i>Renewable Biomass Projects</div>
                                <div className="col-sm-6"><i className="fa fa-check text-primary me-2"></i>Carbon Sequestration</div>
                                <div className="col-sm-6"><i className="fa fa-check text-primary me-2"></i>International Consulting</div>
                                <div className="col-sm-6"><i className="fa fa-check text-primary me-2"></i>Plastic Recycling</div>
                            </div>
                            
                            <marquee className="bg-light p-2 mt-3">
                                <p className="text-primary m-0">Above services are available for opportunities on the African continent and Indian Ocean islands market.</p>
                            </marquee>

                            <div className="d-flex align-items-center mt-4 wow fadeIn" data-wow-delay="0.6s">
                                <div className="bg-primary d-flex align-items-center justify-content-center rounded" style={{ width: "60px", height: "60px" }}>
                                    <i className="fa fa-envelope-open text-white"></i>
                                </div>
                                <div className="ps-4">
                                    <h5 className="mb-2">E-mail us with your questions</h5>
                                    <h6 className="text-primary mb-0">info@unicellusa.com</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5" style={{ minHeight: "500px" }}>
                            <div className="position-relative h-100">
                                <img className="position-absolute w-100 h-100 rounded wow zoomIn" data-wow-delay="0.9s" src="img/about.jpg" style={{ objectFit: "cover" }} alt="About Unicell" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Team Section */}
            <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container py-5">
                    <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{ maxWidth: "600px" }}>
                        <h5 className="fw-bold text-primary text-uppercase">Team Members</h5>
                        <h1 className="mb-0">Professional Staff Ready to Help Your Business</h1>
                    </div>
                    <div className="row g-4">
                        {[
                            { name: "Girish Sharma", role: "Managing Director" },
                            { name: "Nisha Sharma", role: "Director" },
                            { name: "Josia Kamanga", role: "Head of Finance" },
                            { name: "Naomi Kabinda", role: "Head of Human Resource" },
                            { name: "Ganesh Mariyappan", role: "Head of Engineering" },
                            { name: "Lenny Banda", role: "Assistant Accountant" }
                        ].map((member, index) => (
                            <div key={index} className="col-lg-4 col-md-6 wow slideInUp" data-wow-delay={`${0.3 * (index % 3 + 1)}s`}>
                                <div className="team-item bg-light rounded overflow-hidden text-center py-4 shadow-sm">
                                    <h4 className="text-primary">{member.name}</h4>
                                    <p className="text-uppercase m-0">{member.role}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Clientele Section */}
            <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container py-5">
                    <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{ maxWidth: "600px" }}>
                        <h5 className="fw-bold text-primary text-uppercase">Our Clientele</h5>
                    </div>
                    <div className="bg-white p-4 border border-primary rounded">
                        <div className="owl-carousel vendor-carousel">
                            <img src="img/wecycle.jfif" alt="Client" />
                            <img src="img/inside.jfif" alt="Client" />
                            <img src="img/glg_logo.jfif" alt="Client" />
                            <img src="img/ZAFFICO.jpg" alt="Client" />
                            <img src="img/mantle_lab.jfif" alt="Client" />
                            <img src="img/shar.png" alt="Client" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Aboutus;